"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _constants = require("./constants");

var _secretTree = _interopRequireDefault(require("./secret-tree"));

var _secretList = _interopRequireDefault(require("./secret-list"));

var _backToTop = _interopRequireDefault(require("britive-design-system/core/components/backToTop"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

(function () {
  var styles = "/* Add custom scrollbar style for Chrome, Safari, FF and Edge */\n.manage-my-secrets-container {\n  display: flex; }\n  .manage-my-secrets-container .nodes-secrets-tree-container {\n    height: calc(100vh - 170px);\n    z-index: 3; }\n  .manage-my-secrets-container .secrets-policies-tabs-container {\n    padding-left: 3rem;\n    padding-right: 3.5rem;\n    flex-grow: 1;\n    overflow: auto;\n    height: calc(100vh - 170px); }\n    .manage-my-secrets-container .secrets-policies-tabs-container::-webkit-scrollbar {\n      width: 0.5rem;\n      height: 0.5rem; }\n    .manage-my-secrets-container .secrets-policies-tabs-container::-webkit-scrollbar-track {\n      border-radius: 0.5rem;\n      margin-top: 0.125rem; }\n    .manage-my-secrets-container .secrets-policies-tabs-container::-webkit-scrollbar-thumb {\n      border-radius: 0.5rem;\n      background-color: #c6c6c6; }\n    .manage-my-secrets-container .secrets-policies-tabs-container::-webkit-scrollbar-thumb:hover {\n      background-color: #6f6f6f; }\n    .manage-my-secrets-container .secrets-policies-tabs-container .secrets-tab-table-container {\n      padding-top: 3rem; }\n      .manage-my-secrets-container .secrets-policies-tabs-container .secrets-tab-table-container .secrets-eye-icon {\n        color: #6f6f6f; }\n        .manage-my-secrets-container .secrets-policies-tabs-container .secrets-tab-table-container .secrets-eye-icon .disabled-icon {\n          color: #c6c6c6;\n          cursor: not-allowed; }\n";
  var fileName = "secr_MyAllSecrets";
  var element = document.querySelector("style[data-sass-component='secr_MyAllSecrets']");

  if (!element) {
    var styleBlock = document.createElement("style");
    styleBlock.innerHTML = styles;
    styleBlock.setAttribute("data-sass-component", fileName);
    document.head.appendChild(styleBlock);
  } else {
    element.innerHTML = styles;
  }
})();

var TabPanel = function TabPanel(props) {
  var value = props.value,
      index = props.index;
  return value === index && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, props.children);
};

TabPanel.propTypes = {
  value: _propTypes.default.number,
  index: _propTypes.default.number,
  children: _propTypes.default.any
};

var AllSecrets = function AllSecrets(_ref) {
  var history = _ref.history,
      match = _ref.match;

  var _useState = (0, _react.useState)([]),
      _useState2 = _slicedToArray(_useState, 2),
      selectedItemAncestors = _useState2[0],
      setSelectedItemAncestors = _useState2[1];

  var tabContainer = (0, _react.useRef)(null);

  var selectionHandler = function selectionHandler(ancestorsArray) {
    setSelectedItemAncestors(ancestorsArray);
  };

  return /*#__PURE__*/_react.default.createElement("div", {
    className: _constants.classes.secretsManagerContainer
  }, /*#__PURE__*/_react.default.createElement(_secretTree.default, {
    parentsOfSelectedItem: selectedItemAncestors,
    selectionHandler: selectionHandler
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: _constants.classes.secretsPoliciesTabsContainer,
    ref: tabContainer
  }, /*#__PURE__*/_react.default.createElement(_secretList.default, {
    selectedItemAncestors: selectedItemAncestors,
    history: history,
    match: match
  })), /*#__PURE__*/_react.default.createElement(_backToTop.default, {
    id: _constants.backToTopId,
    parentRef: tabContainer
  }));
};

AllSecrets.propTypes = {
  setPageHeader: _propTypes.default.func,
  history: _propTypes.default.any,
  match: _propTypes.default.any
};
var _default = AllSecrets;
exports.default = _default;